import {
  IconButton, ListItem, Typography, useTheme,
} from '@mui/material';
import React from 'react';
import { FiTag } from 'react-icons/fi';
import PropTypes from 'prop-types';
import trim from 'lodash/trim';
import Image from '@components/atoms/Image2';
import MenuChevronRightIcon from '@components/atoms/MenuChevronRightIcon';
import Link from '../../atoms/Link';
import MenuItemBadge from './MenuItemBadge';
import { navigationItemShape } from './propTypes';

export default function MobileMenuItem(props) {
  const {
    item,
    onClick,
    onDrillDown,
  } = props;
  const theme = useTheme();
  const hasMegaMenu = item.megaMenu
    && (item.megaMenu.groups?.length > 0 || item.megaMenu.items?.length > 0);
  const hasItems = item.items?.length > 0 || hasMegaMenu;
  const markedItems = [
    74, 75, 76, 77, 433, 434, 432, 438, 590, 588, 585, 584, 777, 775, 779, 778, 939, 940, 932, 944,
  ];

  const handleDrillDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onDrillDown(item);
  };

  return (
    <Link href={item.path} legacyBehavior>
      <ListItem
        button
        component="a"
        onClick={onClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          ...(item.highlighting === 'bold' && ({
            fontWeight: '900',
          })),
        }}
      >
        <Typography
          component="span"
          sx={{
            mr: 'auto',
            justifyContent: 'flex-start',
            ...(item.highlighting === 'promotion' ? ({
              fontWeight: '700',
            }) : ({
              fontWeight: undefined,
            })),
          }}
        >
          {trim(item.title)}
        </Typography>
        {markedItems.includes(item.id) && (
          <>
            {![76, 432, 585, 779, 944].includes(item.id) && (
              <Image
                alt="Hyundai"
                height={618}
                src="/images/car-brands/hyundai-motor-company-logo-2.svg"
                style={{
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: theme.spacing(1),
                  width: 24,
                  height: 24,
                }}
                width={618}
              />
            )}
            <Image
              alt="Mitsubishi"
              height={172}
              src="/images/car-brands/mitsubishi-logo.svg"
              style={{
                display: 'block',
                marginRight: theme.spacing(1),
                width: 15,
                height: 15,
              }}
              width={172}
            />
          </>
        )}
        {item.props?.badge && (
          <MenuItemBadge
            icon={item.props.badgeIcon}
            label={item.props.badge}
          />
        )}
        {hasItems && (
          <IconButton
            aria-label={trim(item.title)}
            onClick={handleDrillDown}
            size="large"
          >
            <MenuChevronRightIcon />
          </IconButton>
        )}
        {item.highlighting === 'promotion' && (
          <IconButton
            aria-label={trim(item.title)}
          >
            <FiTag
              style={{
                fontWeight: '900',
                color: theme.palette.primary.main,
              }}
            />
          </IconButton>
        )}
      </ListItem>
    </Link>
  );
}

MobileMenuItem.propTypes = {
  item: navigationItemShape.isRequired,
  onClick: PropTypes.func,
  onDrillDown: PropTypes.func,
};
